import { Component, Input } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { OnInit } from "@angular/core";

@Component({
  selector: "despesas-error",
  templateUrl: "./despesas-error.component.html",
  styleUrls: ["./despesas-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class DespesasErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ColumnsExpenses: string[] = [
    "portfolioDocument",
    "portfolioName",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "operationValue",
    "expenseType",
    "settlementDate",
    "details",
    "isNewFavored",
    "favoredName",
    "favoredDocument",
    "favoredBank",
    "favoredBranch",
    "favoredAccount",
    "annotations",
  ];

  ngOnInit(): void {}
}
